export default __webpack_public_path__ + "static/media/banner.9f3183ca.png";